export enum Platform {
  ios = "ios",
  android = "android",
}

export enum AuthMethod {
  apple = "apple",
  google = "google",
  phone = "phone",
  email = "email",
}

export enum ResultType {
  bad_invitation = "bad_invitation",
  bad_user = "bad_user",
  invited = "invited",
  expired = "expired",
  expired_included = "expired_included",
  expired_included_school = "expired_included_school",
}
